import request from '@/utils/request'
const apiPath = '/course/courseSubjectBarrierRecords'
import { downloadBlob } from '@/utils/download'
const courseSubjectBarrierRecordsApi = {
  /**
   * 新增【闯关记录】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【闯关记录】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【闯关记录】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  exportExcel2(query) {
    return request.get(apiPath + '/exportExcel2', { params: query })
  },
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【闯关记录】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【闯关记录】
   */
}
export default courseSubjectBarrierRecordsApi
